import { Directive, Input, HostListener } from '@angular/core';
import { NavigationService } from '@core/services/navigation.service';

@Directive({
    selector: '[hmtNavigationHandler]',
    standalone: false
})
export class NavigationHandlerDirective {
  @Input() route: string;
  @Input() queryParams?: Record<string, any>;

  constructor(private navigationService: NavigationService) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    this.navigationService.handleNavigation(event, this.route, this.queryParams);
  }
} 